// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".testimonial-image[data-v-d589a8e8]{width:730px;height:350px}@media(min-width:768px)and (max-width:991px){.testimonial-image[data-v-d589a8e8]{width:650px;height:300px}}@media(min-width:0)and (max-width:767px){.testimonial-image[data-v-d589a8e8]{width:100%;height:auto}}@media(min-width:0)and (max-width:767px){.testimonial-image img[data-v-d589a8e8]{width:100%}}.testimonial-image__stars[data-v-d589a8e8]{width:102px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
